module.exports = __webpack_public_path__ + "assets/img/11_763_big.e8d6c6f1.jpg";